import { z } from "zod";

export const createManagerSchema = z.object({
	email: z.string().email("Nieprawidłowy adres email"),
	company_name: z.string().min(1, "Nazwa firmy jest wymagana"),
});
export type CreateManagerFormValues = z.infer<typeof createManagerSchema>;

export const addUserToManagerSchema = z.object({
	email: z.string().email("Nieprawidłowy adres email"),
});
export type AddUserToManagerFormValues = z.infer<typeof addUserToManagerSchema>;
